<template>
  <span class="reference-cell d-inline-flex align-items-center">
    <i :class="[typeIcon, 'text-muted', 'mr-2']" style="font-size:0.9rem;" :title="row.type" aria-hidden="true"></i>
    {{ displayValue }}
  </span>
</template>

<script>
const TYPE_ICONS = {
  Invoice: 'fas fa-file-alt',
  'Credit Note': 'fas fa-file-minus',
  Refund: 'fas fa-undo',
  Payment: 'fas fa-credit-card'
}

export default {
  name: 'ReferenceCell',

  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    row: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    displayValue () {
      if (typeof this.value === 'string' && this.value) return this.value
      // Allocation rows carry the counterpart id in FromTransactionId; plain rows use Id.
      var id = this.row.FromTransactionId != null ? this.row.FromTransactionId : this.row.Id
      return id != null ? String(id) : ''
    },
    typeIcon () {
      return TYPE_ICONS[this.row.type] || 'fas fa-file'
    }
  }
}
</script>
